import React, { Suspense, useEffect, useState } from 'react';
import { HashRouter, BrowserRouter } from 'react-router-dom';
import { PageLoader } from '@sumtotal/react-foundation';
import AppLayout from './common/layout/components/AppLayout';
import Breadcrumbs from './common/layout/components/Breadcrumbs';
import Config from './config/Config';
import authService from './authentication/AuthorizeService';
import CorePillarFrame from './modules/core/components/CorePillarFrame';
import CoreMessageListener from './modules/core/components/CoreMessageListener';
import SitemapProvider from './common/layout/components/SitemapProvider';
import bootstrapApplication from './modules/core/services/bootstrapService';
import './config/i18n';
import RouteChangeListener from './RouteChangeListener';
import SecurityQuestions from './modules/core/components/SecurityQuestions';
import Tracker from './analytics/Tracker';
import AppRoutes from './AppRoutes';
import MyGuideTracker from './analytics/MyGuideTracker';
import TrackingProvider from './analytics/TrackingProvider';
import getLogger from './utils/logger';
import RouteLeavingConfirmationModal from './RouteLeavingConfirmationModal';

// Use different router type depending on configuration
const AppRouterComponent = Config.navigationType === 'history' ? BrowserRouter : HashRouter;

const AppRouter = () => {
  const [userAuthStatus, setUserAuthStatus] = useState({
    isAuthenticated: false,
    emulatedUser: ''
  });

  useEffect(() => {
    authService
      .getUser()
      .then((user) => {
        if (user) {
          // To check if its emulation mode.
          if (
            user.profile &&
            user.profile.emulatorusername &&
            user.profile.emulatorusername !== ''
          ) {
            setUserAuthStatus({ isAuthenticated: true, emulatedUser: user.profile.propername });
          } else {
            setUserAuthStatus({ isAuthenticated: true, emulatedUser: '' });
          }
        }
        // bootstrap after successful auth
        if (user) {
          bootstrapApplication();
        }
        return null;
      })
      .catch((errorResponse) => {
        setUserAuthStatus({ isAuthenticated: false, emulatedUser: '' });
        getLogger().error(errorResponse);
      });
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalCallback, setModalCallback] = useState(null);

  const handleModalAction = (flag) => {
    setIsModalOpen(false);
    modalCallback(flag);
  };

  const getUserConfirmation = (message, callback) => {
    setIsModalOpen(true);
    setModalCallback(() => callback);
  };

  return (
    <>
      <AppRouterComponent basename={Config.appPrefix} getUserConfirmation={getUserConfirmation}>
        <AppLayout showStickyHeader={userAuthStatus.emulatedUser !== ''}>
          {userAuthStatus.isAuthenticated && (
            <SitemapProvider emulatedUser={userAuthStatus.emulatedUser} />
          )}
          {/* This component identifies the change in location path */}
          <RouteChangeListener />
          <div className="content grid-print-class">
            {userAuthStatus.isAuthenticated && <CorePillarFrame />}
            <CoreMessageListener />
            {userAuthStatus.isAuthenticated && (
              <TrackingProvider isinSite>
                <Tracker />
              </TrackingProvider>
            )}
            <MyGuideTracker />
            {userAuthStatus.isAuthenticated && <SecurityQuestions />}
            <div
              id="rcore-page-content"
              style={{
                overflow: 'auto',
                position: 'relative',
                height: '100%'
              }}
            >
              {userAuthStatus.isAuthenticated && <Breadcrumbs />}
              {isModalOpen && (
                <RouteLeavingConfirmationModal
                  isOpen={isModalOpen}
                  handleModalAction={handleModalAction}
                />
              )}
              <Suspense fallback={<PageLoader show />}>
                <AppRoutes />
              </Suspense>
            </div>
          </div>
        </AppLayout>
      </AppRouterComponent>
    </>
  );
};

export default AppRouter;
